module.exports = __webpack_public_path__ + "img/edge_hebergements_residence.7f88a4d8.svg";